@if (label) {
<label class="cds-body2 font-color-light3 l-d-ib l-mb-3 cds-dropdown-label">
  {{ label | lang }}@if (required) {
  <span class="cds-coral-text dark-1">*</span>
  }
</label>
}
<div class="cd-autocomplete" [class.cd-autocomplete-flat]="flatPanel">
  <mat-form-field class="example-full-width">
    <input
      (blur)="onBlur()"
      (focus)="onFocus()"
      type="text"
      matInput
      placeholder="{{ (placeholder ? placeholder : '') | lang }}"
      class="cds-input text-field"
      [formControl]="autoCompleteControl"
      [matAutocomplete]="auto"
      #trigger="matAutocompleteTrigger"
      appCdAutocompletePosition="trigger" />
    <mat-autocomplete
      #auto="matAutocomplete"
      class="cd-autocomplete-panel {{ panelClass }} {{ flatPanel ? 'cd-autocomplete-panel-flat' : '' }}"
      [displayWith]="displayFn"
      (closed)="onClosed()"
      (optionSelected)="optionSelectedFn($event)">
      @for (option of optionsDisplayed; track option) {
      <mat-option [value]="option">
        {{ option.label | lang }}
      </mat-option>
      }
    </mat-autocomplete>
    <div class="cd-autcomplete-arrow-wrapper" [class.not-empty]="optionSelected">
      <div class="cd-autcomplete-select-arrow"></div>
      <cds-icon [config]="{ color: '#8E90A2' }" icon="action:button_x_filled" (click)="clearInput()"></cds-icon>
    </div>
  </mat-form-field>
</div>
